// frontend/src/components/AnalysisLogViewer.js

import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AnalysisLogViewer = ({ logContent }) => {
  // --- FIX: Removed the ref and useEffect that caused automatic scrolling ---
  // const endOfLogRef = useRef(null);
  // useEffect(() => {
  //   endOfLogRef.current?.scrollIntoView({ behavior: 'smooth' });
  // }, [logContent]);

  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        height: '100%', 
        overflow: 'auto',
        // --- FIX: Use theme-aware colors instead of hardcoded dark theme ---
        backgroundColor: 'background.paper',
        color: 'text.primary',
        fontFamily: 'monospace',
        p: 2,
      }}
    >
      {/* --- FIX: Styles for wrapping moved here to apply directly to the preformatted text --- */}
      <Typography component="pre" sx={{ 
        fontFamily: 'inherit', 
        margin: 0, 
        whiteSpace: 'pre-wrap', 
        wordBreak: 'break-word' 
      }}>
        {logContent || 'Analysis log will appear here...'}
      </Typography>
      {/* <div ref={endOfLogRef} /> */}
    </Paper>
  );
};

export default AnalysisLogViewer;